import { Injectable } from '@angular/core';

import { IInitialConfig } from '@app/app.module';

import { initialConfig } from '../../../environments/environment';

// @dynamic
@Injectable({
    providedIn: 'root',
})
export class ConfigurationService {
    private readonly _initialConfig: IInitialConfig;

    constructor() {
        this._initialConfig = initialConfig();
    }

    public getData(): IInitialConfig {
        return this._initialConfig;
    }
}
